import {
  assertValidProspectPayload,
  buildProspectPayload as buildLegacyProspectPayload,
  prospectRowFromRecord,
  type ProspectFormValues,
} from '../../prospects/schema'
import type { ProspectPayload, ProspectRow } from '../types/database.types'
import { SchemaValidationError, assertKnownKeys, assertObject } from './strict'

export function buildProspectPayload(
  input: ProspectFormValues | { next_follow_up_at: string },
  authenticatedUserId?: string,
  mode: 'insert' | 'update' = 'insert',
): ProspectPayload {
  if ('next_follow_up_at' in input && Object.keys(input).length === 1) {
    const patch = assertObject(input, 'Prospect follow-up payload')
    assertKnownKeys(patch, ['next_follow_up_at'], 'Prospect follow-up payload')
    const date = new Date(String(patch.next_follow_up_at))

    if (Number.isNaN(date.getTime())) {
      throw new SchemaValidationError('next_follow_up_at must be a valid date.')
    }

    return { next_follow_up_at: date.toISOString() }
  }

  if (!authenticatedUserId) {
    throw new SchemaValidationError(
      'A valid authenticated user is required for a prospect write.',
    )
  }

  const payload = buildLegacyProspectPayload(
    input as ProspectFormValues,
    authenticatedUserId,
    mode,
  )
  assertValidProspectPayload(payload)
  return payload
}

export function mapProspectRow(row: Record<string, unknown>): ProspectRow {
  return prospectRowFromRecord(row) as ProspectRow
}
